import { html } from 'lit';

export const businessLogicStyles = html`<style>
  .zw-business {
    --bl-ink: #233043;
    --bl-muted: #68758a;
    --bl-border: #dfe5ed;
    --bl-red: #ce001e;
    max-width: 1680px;
    margin: 0 auto;
    padding: 34px 32px 48px;
    color: var(--bl-ink);
    font-family: inherit;
  }
  .zw-business *,
  .zw-business *::before,
  .zw-business *::after {
    box-sizing: border-box;
  }
  .zw-business :is(h1, h2, h3, h4, p, dl, dd) {
    margin: 0;
  }
  .zw-business :is(button, select) {
    font: inherit;
  }
  .zw-business :is(button, select, summary, [tabindex]):focus-visible {
    outline: 3px solid #cf1735;
    outline-offset: 4px;
  }
  .zw-business-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 28px;
  }
  .zw-business-eyebrow {
    color: var(--bl-red);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.15em;
    text-transform: uppercase;
  }
  .zw-business h1 {
    margin-top: 7px;
    font-size: 34px;
    font-weight: 750;
    letter-spacing: -0.035em;
    line-height: 1.18;
  }
  .zw-business-intro {
    margin-top: 9px !important;
    color: var(--bl-muted);
    font-size: 14px;
  }
  .zw-business-language {
    display: flex;
    padding: 4px;
    gap: 3px;
    border: 1px solid var(--bl-border);
    border-radius: 10px;
    background: white;
  }
  .zw-business-language button {
    border: 0;
    border-radius: 6px;
    padding: 8px 12px;
    color: var(--bl-muted);
    background: transparent;
    font-size: 12px;
    font-weight: 750;
    cursor: pointer;
  }
  .zw-business-language button[aria-pressed='true'] {
    color: white;
    background: var(--bl-ink);
  }
  .zw-business-selector-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 20px;
    padding: 18px 22px;
    background: white;
    border: 1px solid var(--bl-border);
    border-radius: 14px;
  }
  .zw-business-flow-label {
    font-size: 12px;
    font-weight: 700;
  }
  .zw-business select {
    min-height: 42px;
    border: 1px solid #ccd5e1;
    border-radius: 8px;
    padding: 9px 38px 9px 12px;
    color: var(--bl-ink);
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
  .zw-business-selector-row select {
    min-width: 280px;
    max-width: 100%;
    flex: 1;
  }
  .zw-business-path-count {
    color: var(--bl-muted);
    font-size: 11px;
    white-space: nowrap;
  }
  .zw-business-overview {
    display: grid;
    grid-template-columns: 1.1fr 1fr;
    gap: 28px;
    margin: 24px 0;
    padding: 4px 2px;
  }
  .zw-business-overview h2 {
    margin-bottom: 8px;
    font-size: 22px;
    letter-spacing: -0.025em;
    font-weight: 700;
    line-height: 1.3;
  }
  .zw-business-overview-main > p {
    color: var(--bl-muted);
    font-size: 13px;
    line-height: 1.7;
    max-width: 650px;
  }
  .zw-business-overview dl {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding-left: 26px;
    border-left: 1px solid var(--bl-border);
  }
  .zw-business-overview dt {
    margin: 2px 0 7px;
    font-size: 10px;
    color: var(--bl-muted);
    font-weight: 750;
    text-transform: uppercase;
    letter-spacing: 0.045em;
  }
  .zw-business-overview dd {
    font-size: 12px;
    line-height: 1.65;
  }
  .zw-business-workspace {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 338px;
    gap: 20px;
    align-items: start;
  }
  .zw-business-canvas-panel {
    min-width: 0;
    border: 1px solid var(--bl-border);
    border-radius: 16px;
    background: white;
    overflow: hidden;
    box-shadow: 0 5px 18px #20324a04;
  }
  .zw-business-canvas-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
    padding: 20px 22px 14px;
  }
  .zw-business-canvas-toolbar h3 {
    font-size: 14px;
    font-weight: 750;
  }
  .zw-business-canvas-toolbar p {
    margin-top: 5px;
    color: var(--bl-muted);
    font-size: 11px;
  }
  .zw-business-zoom {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 3px;
    border: 1px solid var(--bl-border);
    border-radius: 8px;
    background: #fff;
  }
  .zw-business-zoom button {
    height: 30px;
    min-width: 30px;
    padding: 4px 7px;
    border: 0;
    border-radius: 5px;
    background: transparent;
    color: var(--bl-ink);
    font-size: 18px;
    cursor: pointer;
  }
  .zw-business-zoom button:hover {
    background: #f0f3f7;
  }
  .zw-business-zoom button:disabled {
    opacity: 0.3;
    cursor: default;
  }
  .zw-business-zoom output {
    width: 45px;
    text-align: center;
    font-size: 11px;
    color: var(--bl-muted);
    font-variant-numeric: tabular-nums;
  }
  .zw-business-zoom button.zw-business-fit {
    margin-left: 4px;
    padding: 4px 10px;
    border-left: 1px solid var(--bl-border);
    border-radius: 0 5px 5px 0;
    font-size: 11px;
    font-weight: 700;
  }
  .zw-business-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0 22px 16px;
    border-bottom: 1px solid #edf0f5;
  }
  .zw-business-legend > span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--bl-muted);
    font-size: 10px;
  }
  .zw-business-legend i {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    background: #9aa8bc;
  }
  .zw-business-legend i.start {
    border-radius: 50%;
    background: #4f819f;
  }
  .zw-business-legend i.decision {
    transform: rotate(45deg);
    background: #c29433;
  }
  .zw-business-legend i.outcome {
    border-radius: 50%;
    background: #528e75;
  }
  .zw-business-viewport {
    width: 100%;
    max-height: 740px;
    min-height: 380px;
    overflow: auto;
    overscroll-behavior: contain;
    padding: 16px;
    background-color: #fcfdff;
    background-image: radial-gradient(#ced6e2 0.8px, transparent 0.8px);
    background-size: 18px 18px;
    scrollbar-width: thin;
    scrollbar-color: #bec9d7 transparent;
  }
  .zw-business-scaled {
    position: relative;
    margin: 0 auto;
  }
  .zw-business-world {
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: top left;
  }
  .zw-business-connectors {
    position: absolute;
    inset: 0;
    overflow: visible;
    pointer-events: none;
  }
  .zw-business-connectors > path {
    fill: none;
    stroke: #7d8fa5;
    stroke-width: 2;
    stroke-linejoin: round;
  }
  .zw-business-connectors > path.selected {
    stroke: #ad4a5e;
    stroke-width: 2.2;
  }
  .zw-business-connectors > path.bridge-gap {
    stroke: #fcfdff;
    stroke-width: 8;
    stroke-linecap: butt;
  }
  .zw-business-node {
    position: absolute;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    padding: 12px 16px;
    background: #fff;
    border: 1px solid #cfd9e5;
    border-radius: 11px;
    box-shadow: 0 3px 9px #263a5910;
    color: var(--bl-ink);
    text-align: left;
    cursor: pointer;
    transition:
      border-color 0.15s,
      box-shadow 0.15s;
  }
  .zw-business-node:hover {
    border-color: #8c9cb2;
    box-shadow: 0 5px 14px #25395418;
  }
  .zw-business-node.selected {
    border: 2px solid var(--bl-red);
    box-shadow:
      0 0 0 4px #ce001e0b,
      0 4px 12px #263a5912;
  }
  .zw-business-node-kind {
    display: flex;
    align-items: center;
    gap: 7px;
    color: #77869a;
    font-size: 9px;
    font-weight: 650;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  .zw-business-node-kind > span {
    font-size: 9px;
    font-variant-numeric: tabular-nums;
    color: #97a2b2;
  }
  .zw-business-node strong {
    display: block;
    font-size: 13px;
    line-height: 1.25;
    font-weight: 750;
  }
  .zw-business-node-summary {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #6b7b90;
    font-size: 10px;
    line-height: 1.35;
  }
  .zw-business-node.start {
    border-radius: 28px;
    border-color: #abc6d8;
    background: #f3f8fc;
  }
  .zw-business-node.outcome {
    border-color: #afcfbf;
    background: #f2f9f5;
  }
  .zw-business-node.start.selected,
  .zw-business-node.outcome.selected {
    border-color: var(--bl-red);
  }
  .zw-business-node.decision {
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 18px 45px;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    background: #c6a65d;
    clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
    text-align: center;
  }
  .zw-business-node.decision::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: 1.7px;
    background: #fffcf2;
    clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
  }
  .zw-business-node.decision.selected {
    background: var(--bl-red);
  }
  .zw-business-node.decision.selected::before {
    inset: 2.5px;
    background: #fff8f4;
  }
  .zw-business-node.decision:hover::before {
    background: #fff7e0;
  }
  .zw-business-node.decision strong {
    font-size: 12px;
    line-height: 1.3;
    max-width: 160px;
  }
  .zw-business-node.decision .zw-business-node-kind,
  .zw-business-node.decision .zw-business-node-summary {
    display: none;
  }
  .zw-business-node.decision:focus-visible {
    outline: none;
    background: #ce001e;
  }
  .zw-business-node.decision:focus-visible::before {
    inset: 4px;
  }
  .zw-business-edge-label {
    position: absolute;
    z-index: 3;
    max-width: 180px;
    padding: 3px 7px;
    border: 1px solid #e5e9f0;
    border-radius: 5px;
    background: #fff;
    color: #435871;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
    transform: translate(-50%, -50%);
    pointer-events: none;
    box-shadow: 0 1px 3px #24355206;
  }
  .zw-business-map-footer {
    padding: 12px 22px;
    border-top: 1px solid #edf0f5;
    color: #7b889b;
    font-size: 10px;
    line-height: 1.5;
  }
  .zw-business-detail {
    border: 1px solid var(--bl-border);
    border-radius: 16px;
    background: #fff;
    min-width: 0;
    overflow: hidden;
    position: sticky;
    top: 18px;
  }
  .zw-business-detail-head {
    padding: 22px 22px 20px;
    border-bottom: 1px solid #edf0f5;
  }
  .zw-business-detail select {
    display: block;
    width: 100%;
    font-size: 11px;
    margin: 12px 0 18px;
    font-weight: 500;
    min-width: 0;
  }
  .zw-business-detail-kind {
    display: inline-block;
    margin-bottom: 10px;
    border-radius: 4px;
    padding: 4px 7px;
    font-size: 9px;
    color: #61738b;
    background: #f0f3f7;
    font-weight: 750;
    text-transform: uppercase;
    letter-spacing: 0.045em;
  }
  .zw-business-detail-kind.start {
    color: #386784;
    background: #eef6fb;
  }
  .zw-business-detail-kind.decision {
    color: #8a6b25;
    background: #fcf5df;
  }
  .zw-business-detail-kind.outcome {
    color: #3e775e;
    background: #edf7f0;
  }
  .zw-business-detail h3 {
    font-size: 19px;
    line-height: 1.3;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  .zw-business-detail-head > p:last-child {
    margin-top: 10px;
    color: var(--bl-muted);
    font-size: 12px;
    line-height: 1.6;
  }
  .zw-business-detail-body {
    padding: 0 22px 22px;
    max-height: 640px;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #bec9d7 transparent;
  }
  .zw-business-detail-body > section {
    padding-top: 20px;
  }
  .zw-business-detail h4 {
    margin-bottom: 8px;
    font-size: 11px;
    line-height: 1.4;
    font-weight: 800;
  }
  .zw-business-detail-body section p {
    margin: 8px 0 0;
    color: #5d6d82;
    font-size: 12px;
    line-height: 1.7;
    overflow-wrap: anywhere;
  }
  .zw-business-detail-body .zw-business-auth-summary {
    margin-top: 18px;
    padding: 14px 15px;
    border: 1px solid #dce5ee;
    border-left: 3px solid #6d8aa4;
    border-radius: 8px;
    background: #f6f9fc;
  }
  .zw-business-auth-summary p {
    font-size: 11px !important;
    line-height: 1.65 !important;
  }
  .zw-business-auth-summary strong {
    display: block;
    color: #344d65;
    font-size: 10px;
    margin-bottom: 2px;
  }
  .zw-business-auth-summary .zw-business-auth-eyebrow {
    margin: 0 0 8px;
    color: #6a7c90;
    font-size: 9px !important;
    font-weight: 750;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  .zw-business-notes {
    margin-top: 20px;
    padding: 16px !important;
    border-radius: 10px;
    background: #f6f8fb;
  }
  .zw-business-notes ul {
    margin: 0;
    padding-left: 14px;
    color: #66758a;
    font-size: 11px;
    line-height: 1.65;
  }
  .zw-business-notes li + li {
    margin-top: 7px;
  }
  .zw-business-sources {
    margin-top: 22px;
    border-top: 1px solid #edf0f5;
    padding-top: 15px;
    color: #78869a;
    font-size: 10px;
  }
  .zw-business-sources summary {
    cursor: pointer;
    font-size: 10px;
    font-weight: 650;
  }
  .zw-business-sources p {
    margin-top: 12px;
    line-height: 1.6;
  }
  .zw-business-sources ul {
    list-style: none;
    margin: 12px 0;
    padding: 0;
  }
  .zw-business-sources li + li {
    margin-top: 9px;
  }
  .zw-business-sources code {
    display: block;
    margin-top: 3px;
    font-size: 9px;
    word-break: break-word;
  }
  .zw-business-thresholds {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 14px !important;
  }
  .zw-business-thresholds > div {
    padding: 7px 10px;
    background: #f4f6f9;
    border-radius: 6px;
  }
  .zw-business-thresholds dt {
    font-size: 9px;
  }
  .zw-business-thresholds dd {
    margin-top: 3px;
    color: #45566f;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
    font-weight: 700;
  }
  .zw-business-reference-note {
    margin: 18px 2px 0 !important;
    max-width: 1050px;
    color: #7c899a;
    font-size: 11px;
    line-height: 1.65;
  }
  .zw-business-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  @media (min-width: 1500px) {
    .zw-business-workspace {
      grid-template-columns: minmax(0, 1fr) 370px;
      gap: 24px;
    }
  }
  @media (max-width: 1050px) {
    .zw-business {
      padding: 26px 20px 40px;
    }
    .zw-business-workspace {
      grid-template-columns: minmax(0, 1fr) 300px;
      gap: 14px;
    }
    .zw-business-overview {
      grid-template-columns: 1fr;
      gap: 18px;
    }
    .zw-business-overview dl {
      border: 0;
      padding: 0;
    }
    .zw-business-detail-head {
      padding: 18px;
    }
    .zw-business-detail-body {
      padding: 0 18px 18px;
    }
  }
  @media (max-width: 1280px) {
    .zw-business-workspace {
      grid-template-columns: minmax(0, 1fr);
    }
    .zw-business-detail {
      position: static;
    }
    .zw-business-detail-body {
      max-height: none;
    }
    .zw-business-viewport {
      max-height: 650px;
    }
  }
  @media (max-width: 820px) {
    .zw-business-selector-row {
      align-items: flex-start;
    }
    .zw-business-flow-label {
      width: 100%;
    }
    .zw-business-selector-row select {
      min-width: 0;
    }
    .zw-business-path-count {
      align-self: center;
    }
  }
  @media (max-width: 520px) {
    .zw-business {
      padding: 22px 12px 32px;
    }
    .zw-business h1 {
      font-size: 28px;
    }
    .zw-business-heading {
      align-items: flex-start;
      gap: 12px;
    }
    .zw-business-intro {
      max-width: 230px;
      font-size: 12px;
    }
    .zw-business-overview dl {
      grid-template-columns: 1fr;
      gap: 14px;
    }
    .zw-business-overview h2 {
      font-size: 20px;
    }
    .zw-business-selector-row {
      padding: 15px;
      gap: 10px;
    }
    .zw-business-selector-row select {
      width: 100%;
      flex: auto;
    }
    .zw-business-path-count {
      display: none;
    }
    .zw-business-canvas-toolbar {
      padding: 18px 16px 12px;
    }
    .zw-business-legend {
      padding: 0 16px 14px;
      gap: 12px;
    }
    .zw-business-viewport {
      padding: 10px;
    }
    .zw-business-map-footer {
      padding: 12px 16px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .zw-business * {
      transition: none !important;
      scroll-behavior: auto !important;
    }
  }
</style>`;
